module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<ul> ';
 if ( isUser ) { 
__p+=' <li><a class="icon icon-material icon-labelled icon-small icon-upgrade" href="#" data-click="functionality-migrate">'+
((__t=( i18n.tc( "ResponseFunctionality", "Legacy migrate" ) ))==null?'':__t)+
'</a> ';
 } 
__p+=' ';
 if ( isInstaller ) { 
__p+=' </li><li><a class="icon icon-material icon-labelled icon-small icon-installed" href="#" data-click="functionality-installed">'+
((__t=( i18n.tc( "ResponseFunctionality", "Installed devices" ) ))==null?'':__t)+
'</a> ';
 } 
__p+=' ';
 if ( isCustomer ) { 
__p+=' </li><li><a class="icon icon-material icon-labelled icon-small icon-invoice" href="#" data-click="functionality-invoices">'+
((__t=( i18n.tc( "ResponseFunctionality", "Invoices" ) ))==null?'':__t)+
'</a> ';
 } 
__p+=' ';
 if ( isCustomer || isUnit || isUser ) { 
__p+=' </li><li><a class="icon icon-material icon-labelled icon-small icon-log" href="#" data-click="functionality-log">'+
((__t=( i18n.tc( "ResponseFunctionality", "Log" ) ))==null?'':__t)+
'</a> ';
 } 
__p+=' </li></ul>';
}
return __p;
};
